class FiltersForm extends HTMLElement {
  constructor() {
    super();

    this.DEBOUNCE_DELAY = 500;

    FiltersForm.isBlog = this.hasAttribute("data-is-blog");

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.form = this.querySelector("[data-filters-form]");
    this.apply = this.querySelector("[data-filter-apply]");
    this.debouncedOnSubmit = debounce(event => this.onSubmitHandler(event), this.DEBOUNCE_DELAY);
    this.form.addEventListener("input", this.debouncedOnSubmit.bind(this));
    this.isBlog = this.dataset.isBlog === "true";

    this.addDrawerAccordionSelectListener();
  }

  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state ? event.state.searchParams : FiltersForm.searchParamsInitial;

      if (searchParams === FiltersForm.searchParamsPrev) return;

      FiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    const facets = document.querySelectorAll("[data-filters-refinements]");

    facets.forEach(element => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FiltersForm.searchParamsPrev = searchParams;

    const sections = FiltersForm.getSections();

    sections.forEach((section) => {
      let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

      if (FiltersForm.isBlog) {
        const baseUrl = document.querySelector("[data-filters]").dataset.url;
        const path = `${baseUrl}${searchParams ? "/tagged/" + searchParams : ""}`;

        url = `${path}?section_id=${section.section}`;
      }

      const filterDataUrl = element => element.url === url;

      FiltersForm.filterData.some(filterDataUrl)
        ? FiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        FiltersForm.filterData = [...FiltersForm.filterData, { html, url }];
        FiltersForm.renderFunctions(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FiltersForm.filterData.find(filterDataUrl).html;

    FiltersForm.renderFunctions(html, event);
  }

  static renderFunctions(html) {
    FiltersForm.renderFilters(html);
    FiltersForm.renderResultsContainer(html);
    FiltersForm.renderResultsCount(html);
    FiltersForm.renderDesktopFooterActiveFacetsBar(html);
    FiltersForm.renderPagination(html);
    FiltersForm.renderActiveFilterCount(html);
    FiltersForm.renderDrawerAccordionSortActiveLabel(html);
  }

  static renderResultsContainer(html) {
    const gridContainer = html.querySelector("[data-results-grid]");
    const newGridContainer = document.querySelector("[data-results-grid]");

    newGridContainer.innerHTML = gridContainer.innerHTML;
  }

  static renderActiveFilterCount(html) {
    const count = html.querySelectorAll("[data-filter-active-count]");
    const newCount = document.querySelectorAll("[data-filter-active-count]");

    newCount.forEach((element, index) => {
      element.innerHTML = count[index].innerHTML;
    });
  }

  static renderResultsCount(html) {
    const count = html.querySelectorAll("[data-results-count]");
    const container = document.querySelectorAll("[data-results-count]");

    container.forEach((element, index) => {
      element.innerHTML = count[index].innerHTML;
    });
  }

  static renderFilters(html) {
    const filterOptionsDesktop = html.querySelectorAll("[data-filters-desktop] [data-filter]");
    const filterOptionsMobile = html.querySelectorAll("[data-filters-drawer] [data-filter]");

    FiltersForm.renderDeviceFilters(filterOptionsDesktop);
    FiltersForm.renderDeviceFilters(filterOptionsMobile, "drawer");
    FiltersForm.renderActiveFacets(html);
  }

  static renderDeviceFilters(filters, type = 'desktop') {
    const filtersArray = Array.from(filters);

    filtersArray.forEach(element => {
      const index = element.dataset.index;
      const options = element.querySelector("[data-filter-options]");
      const target = document.querySelector(`[data-filters-${type}] [data-filter][data-index="${index}"]`);
      const newOptions = target.querySelector("[data-filter-options]");

      if (options && newOptions) newOptions.innerHTML = options.innerHTML;
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ["[data-filters-refinements]"];

    activeFacetElementSelectors.forEach(selector => {
      const activeFacetsElement = html.querySelector(selector);
      const newActiveFacetsElement = document.querySelector(selector)

      if (!activeFacetsElement || !newActiveFacetsElement) return;

      newActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
    })

    FiltersForm.toggleActiveFacets(false);
  }

  static renderDrawerAccordionSortActiveLabel(html) {
    const sortSelectLabel = html.querySelector("[data-filters-accordion-sort-label]");
    const newSortSelectLabel = document.querySelector("[data-filters-accordion-sort-label]");

    if (sortSelectLabel && newSortSelectLabel) newSortSelectLabel.innerHTML = sortSelectLabel.innerHTML;
  }

  static renderDesktopFooterActiveFacetsBar(html) {
    const footer = html.querySelector("[data-filter-footer]");
    const newFooter = document.querySelector("[data-filter-footer]");

    if (footer && newFooter) newFooter.innerHTML = footer.innerHTML;
  }

  static renderPagination(html) {
    const pagination = html.querySelector("[data-pagination]");
    const newPagination = document.querySelector("[data-pagination]");
    const resultsSection = document.querySelector("[data-results-section]");

    if (newPagination && pagination) newPagination.replaceWith(pagination);
    if (newPagination && !pagination) newPagination.innerHTML = "";
    if (!newPagination && pagination) {
      resultsSection.insertAdjacentElement("afterend", pagination);
    }
  }

  static updateURLHash(searchParams) {
    if (FiltersForm.isBlog) {
      const baseUrl = document.querySelector("[data-filters]").dataset.url;
      const path = `${baseUrl}${searchParams ? "/tagged/" + searchParams : ""}`;

      history.pushState({ searchParams }, '', `${path}`);
    } else {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }
  }

  static getSections() {
    return [{ section: document.querySelector("[data-results-grid]").dataset.section }];
  }

  addSyncInputListener(event, form) {
    const target = event.target;

    if (target.type === "checkbox") {
      const name = target.name;
      const value = target.value;
      const allInputsWithSameNameAndValue = form.querySelectorAll(`input[name="${name}"][value="${value}"]`);

      allInputsWithSameNameAndValue.forEach(input => {
        if (input !== target) {
          input.checked = target.checked;
        }
      });
    }
  }

  addDrawerAccordionSelectListener() {
    const select = this.querySelector("[data-filters-accordion-sort]");

    if (!select) return;

    const options = select.querySelectorAll("[data-filters-accordion-sort-option]");
    const activeLabel = select.querySelector("[data-filters-accordion-sort-label]");

    options.forEach(option => {
      option.addEventListener("click", () => {
        activeLabel.innerHTML = option.innerHTML;

        publish(PUB_SUB_EVENTS.selectOption, option.dataset.value);
      });
    });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const formProps = Object.fromEntries(formData);

    return FiltersForm.isBlog
      ? Object.values(formProps).toString()
      : new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = document.querySelector("[data-filters-form]");

    this.addSyncInputListener(event, form);
    this.onSubmitForm(this.createSearchParams(form), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FiltersForm.toggleActiveFacets();

    const href = event.target.href;

    let url = FiltersForm.isBlog ? href : href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?") + 1);

    if (FiltersForm.isBlog) {
      url = href.indexOf('/tagged/') === -1 ? "" : href.slice(href.indexOf('/tagged/') + 8);
    }

    FiltersForm.renderPage(url);
  }
}

FiltersForm.filterData = [];
FiltersForm.searchParamsInitial = window.location.search.slice(1);
FiltersForm.searchParamsPrev = window.location.search.slice(1);
FiltersForm.setListeners();

customElements.define('filters-form', FiltersForm);

class FilterRemove extends HTMLElement {
  constructor() {
    super();

    this.addListeners();
  }

  addListeners() {
    this.addEventListener('click', event => this.closeFilter(event));
    this.addEventListener('keyup', event => {
      if (event.code === 'Enter') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest("[data-filters]");

    form.onActiveFilterClick(event);
  }
}

customElements.define('filter-remove', FilterRemove);